<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div>
          <h5 class="vue-title pull-left custom-header">
            <strong>{{ $t("NOTIFICATION") }}一覧</strong>
          </h5>

          <b-input-group
            class="pull-right search-text-box notif-search"
          >
            <template v-slot:prepend>
              <b-input-group-text @click="onSerach">
                <em class="fa fa-search"></em>
              </b-input-group-text>
            </template>
            <b-form-input
              size="sm"
              @keyup.enter="onSerach"
              v-model="searchKeyword"
              autocomplete="off"
            ></b-form-input>
          </b-input-group>

          <b-input-group
            class="pull-right search-text-box custom-drop-down"
          >
            <b-form-select
              v-model="selectedFilterItem"
              id="authority"
              :options="filterList"
              class="mb-3"
              value-field="id"
              text-field="name"
              v-on:change="getSelectedItem"
              disabled-field="notEnabled"
              placeholder="表示"
            ></b-form-select>
          </b-input-group>
        </div>

        <c-table
          :table-data="partnerNotification.list"
          :fields="fields"
          :per-page="10"
          striped
          hover
          :dbClick="dbClick"
          :total="partnerNotification.pageTotal"
          :update="update"
          :edit="edit"
          :delete="delet"
          :pagination="pagination"
          :sortTable="sortTable"
          :isBusy="isBusy"
        ></c-table>
        <nav>
          <div class="pagination-module">
            <b-pagination
              :total-rows="partnerNotification.pageTotal"
              @change="pagination"
              :per-page="10"
              v-model="currentPage"
              :prev-text="$t('FORWARD')"
              :next-text="$t('NEXT')"
            />
          </div>
        </nav>
        <b-modal
          size="lg"
          id="modal-read"
          centered
          :title="notificationForm.title"
          hide-footer
          @hidden="close"
        >
          <p v-html="notificationForm.message" class="htmlPadding"></p>
          <b-row class="buttons-align-right" >
            <span class="time_date"
              >{{
                notificationForm.notify_date ? notificationForm.notify_date : ""
              }}
              &nbsp;
              {{
                notificationForm.notify_time
                  ? getTimeFormet(notificationForm.notify_time)
                  : ""
              }}</span
            >
          </b-row>
        </b-modal>
        <b-modal id="modal-delete" hide-footer>
          <template v-slot:modal-title>{{ $t("DELETECONFIRMATION") }}</template>
          <p class="my-2">
            「クリニック」提携先マスターを削除しますがよろしいですか？
          </p>
          <hr />
          <b-row>
            <b-col class="col-6"></b-col>
            <b-col>
              <b-button
                variant="outline-danger"
                class="buttons-align-right"
                size="sm"
                @click="deleteItem()"
                >{{ $t("DELETE") }}</b-button
              >

              <b-button
                variant="outline-secondary"
                class="buttons-align-right"
                size="sm"
                @click="$bvModal.hide('modal-delete')"
                >{{ $t("CANCEL") }}</b-button
              >
            </b-col>
          </b-row>
        </b-modal>

        <b-modal id="modal-Status" hide-footer>
          <template v-slot:modal-title>
            {{ $t("STATUSCHANGECONFIRMATION") }}
          </template>
          <p>ステータスを変更してもよろしいですか？</p>
          <hr />
          <b-row>
            <b-col>
              <b-button
                variant="outline-primary"
                size="sm"
                class="buttons-align-right"
                @click="StatusChange()"
                >{{ $t("SUBMIT") }}</b-button
              >

              <b-button
                variant="outline-secondary"
                class="buttons-align-right"
                size="sm"
                @click="$bvModal.hide('modal-Status')"
                >{{ $t("CANCEL") }}</b-button
              >
            </b-col>
          </b-row>
        </b-modal>
      </div>
      <br />
    </div>
  </div>
</template>
<script>
import cTable from "@/components/Table.vue";
import { pickAs } from "@/shared/utils.js";
import { TimeConversion } from "@/shared/utils.js";
import {
  GET_PARTNER_NOTIFICATION_LIST,
  UPDATE_NOIFICATION_STATUS,
  SEND_NOTIFICATION_COUNT
} from "@/store/actions.type";
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "notificationList",
  data() {
    return {
      pickAs: pickAs,
      TimeConversion: TimeConversion,
      filterList: [
        { name: "すべて", id: "" },
        { name: "未読", id: "unread" },
        { name: "既読", id: "read" }
      ],
      selectedFilterItem: "",
      selectedRow: {},
      fields: [],
      currentPage: 1,
      isBusy: true,
      searchKeyword: "",
      notify_type: "",
      notificationForm: {
        id: "",
        notify_type: "",
        title: "",
        message: "",
        notify_date: " ",
        notify_on: "",
        notify_time: ""
      }
    };
  },
  /*Initilizing the Imported Components */
  components: { cTable },
  methods: {
    /* Pagintaion */
    pagination(page) {
      this.loadTableData(page);
    },
    /**
     * To load the table data
     * Input @param {page} currentPageCount the page number of data you want
     * Output {object} table data
     */
    async loadTableData(page) {
      this.currentPage = page;
      this.isBusy = true;
      await this.$store.dispatch(GET_PARTNER_NOTIFICATION_LIST, {
        notify_type: this.notify_type,
        search_query: this.searchKeyword,
        field: this.sortField,
        sort: this.sortDirection,
        page: this.currentPage,
        status: this.selectedFilterItem
      });
      this.isBusy = false;
    },
    /**
     * Sort function on  table
     * Input 1.@param {String} sortField name of the Field , 2.@param {String} sortDirection Direction of the Sort(Ascending or Descending)
     * Output @param {List}   response.list  Filtered List
     */
    async sortTable(field, direction) {
      this.isBusy = true;
      this.sortField = field;
      this.sortDirection = direction;
      await this.$store.dispatch(GET_PARTNER_NOTIFICATION_LIST, {
        search_query: this.searchKeyword,
        field: this.sortField,
        sort: this.sortDirection,
        page: this.currentPage,
        status: this.notify_type
      });
      this.isBusy = false;
    },
    /**
     * View Detials of the  Notification
     * Input @param {object} row Seleted Row object
     * Output  @param {object} row  bind the selected to row to the view Modal
     */
    async dbClick(record) {
      this.selectedRow = record;
      this.notificationForm = this.pickAs(this.selectedRow, {
        notify_type: "mig_notification.notify_type",
        title: "mig_notification.title",
        message: "mig_notification.message",
        notify_date: "mig_notification.notify_date",
        notify_on: "mig_notification.notify_on",
        notify_time: "mig_notification.notify_time",
        id: "mig_notification.id"
      });
      let payload = {
        notification_id: this.selectedRow.mig_notification.id,
        status: "read"
      };
      this.$bvModal.show("modal-read");

      await this.$store.dispatch(UPDATE_NOIFICATION_STATUS, payload);
      if (this.partnerNotification.list.length == 1) {
        this.pagination(1);
      } else {
        this.pagination(this.currentPage);
      }
    },
    /**
     * Filter on function on  table Date
     * Input @param {String} notify_type Type of the table date
     * Output @param {List}   response.list  Filtered List
     */
    async getSelectedItem(myarg) {
      this.notify_type = myarg;
      let payload = {
        status: this.selectedFilterItem,
        page: 1,
        field: this.sortField,
        sort: this.sortDirection,
        search_query: this.searchKeyword
      };

      this.isBusy = true;
      await this.$store.dispatch(GET_PARTNER_NOTIFICATION_LIST, payload);
      this.isBusy = false;
    },
    /**
     * onSearch function on  table
     * Input @param {String} search_query Search keyword
     * Output @param {List}   response.list  Filtered List
     */
    onSerach() {
      this.pagination(1);
    },
    /**
     * to get the time in  HH:mm:ss format
     * Input @param {Time} time time which we need to convert
     * Output @param {Time}   time which is converted  HH:mm:ss format
     */
    getTimeFormet(time) {
      return moment(time, "HH:mm:ss").format("HH:mm");
    }
  },
  computed: {
    ...mapGetters(["partnerNotification"])
  },
  created() {
    this.$store.dispatch(SEND_NOTIFICATION_COUNT);
    this.$store
      .dispatch(GET_PARTNER_NOTIFICATION_LIST, { field: "id", sort: "asce" })
      .then(data => {
        this.isBusy = false;
      });
    this.fields = [
      {
        key: "partnernotify_date_time",
        label: this.$t("通知日"),
        class: "text-left",
        sortable: true
      },
      {
        key: "mig_notification.title",
        label: this.$t("SUBJECT"),
        sortable: true,
        class: "text-left"
      },
      {
        key: "mig_notification.message",
        label: this.$t("内容"),
        sortable: true,
        class: "text-left"
      },

      {
        key: "notification_status",
        label: this.$t("ステータス"),
        sortable: true
      }
    ];
  }
};
</script>
<style lang="scss">
.htmlPadding p {
  margin-bottom: 0;
}
.htmlPadding ol {
  margin-bottom: 0;
}
.htmlPadding ul {
  margin-bottom: 0;
}

.search-text-box {
  width: 200px;
  margin: 10px 0px;
}
.custom-drop-down {
  width: 200px;
  margin: 10px 10px 00px 0px;
  margin-right: 10px;
}
.notif-search{
  width:200px;margin:10px 00px;
}
</style>
